<template>
  <el-container class="fill-in header-left-main-layout" :class="$root.siteRenderer">
    <template>
      <!--左侧菜单栏-->
      <el-aside v-if="$root.siteRenderer == 'pc'" :class="{collapsed: !!$root.isMenuCollapsed}">
        <SideBar/>
      </el-aside>
    </template>
    <el-container>
      <!--顶部栏-->
      <el-header>
        <TopBar/>
        <TabsNav/>
        <Breadcrumb/>
      </el-header>
      <!--主内容区-->
      <el-main class="main-container">
        <transition name="fade">
          <template v-if="isTabbedMenu">
            <keep-alive :max="6">
              <router-view/>
            </keep-alive>
          </template>
        </transition>
        <template v-if="!isTabbedMenu">
          <keep-alive >
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"/>
        </template>
        <IFrameHolder/>
        <Footer/>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  import { isTabbedMenu } from '@/config/menu';
  import TopBar from './components/TopBar'
  import SideBar from './components/SideBar'
  import Breadcrumb from '@/framework/components/Breadcrumb'
  import TabsNav from '@/framework/components/TabsNav'
  import Footer from '@/framework/components/Footer'
  import IFrameHolder from '@/framework/components/iframe/IFrameHolder'

  export default {
    name: 'HeaderLeftMainLayout',
    data(){
      return {
        isTabbedMenu
      }
    },
    components: {
      TopBar,
      SideBar,
      Footer,
      IFrameHolder,
      Breadcrumb,
      TabsNav
    }
  };
</script>
